// useV2OktaExchange.js
import { useState, useEffect } from 'react';
import { exchangeOktaCode, setLocalStorageAuth } from '../services/v2AuthService';

/**
 * On mount: checks URL hash for okta_code + okta_success=true.
 * If found: exchanges code for JWT and calls onSuccess.
 *
 * @param {Object} options
 * @param {Function} options.onSuccess - Called after successful exchange; parent navigates to home
 * @returns {{ exchangeLoading: boolean, exchangeError: string }}
 */
function useV2OktaExchange({ onSuccess }) {
  const [exchangeLoading, setExchangeLoading] = useState(false);
  const [exchangeError, setExchangeError] = useState('');

  useEffect(() => {
    const hash = window.location.hash;
    if (!hash.includes('okta_success=true')) return;

    const params = new URLSearchParams(hash.replace(/^.*\?/, ''));
    const code = params.get('okta_code');
    if (!code) return;

    console.log('[useV2OktaExchange.js] r1: Okta code detected in URL hash, exchanging...');

    (async () => {
      setExchangeLoading(true);
      setExchangeError('');
      try {
        const data = await exchangeOktaCode(code);
        setLocalStorageAuth(data);
        console.log('[useV2OktaExchange.js] r2: Okta exchange success');
        onSuccess();
      } catch (err) {
        console.log('[useV2OktaExchange.js] r3: Okta exchange failed', err?.response?.status);
        setExchangeError('Okta sign-in failed. Please try again.');
        setExchangeLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Run once on mount only

  return { exchangeLoading, exchangeError };
}

export default useV2OktaExchange;
